/**
 * @generated SignedSource<<02546750e2399d1890569cbc00cbfef2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkActiveCashbackFidelityBalance_charge$data = {
  readonly customer: {
    readonly cashbackFidelityBalance: number;
  } | null | undefined;
  readonly " $fragmentType": "PaymentLinkActiveCashbackFidelityBalance_charge";
};
export type PaymentLinkActiveCashbackFidelityBalance_charge$key = {
  readonly " $data"?: PaymentLinkActiveCashbackFidelityBalance_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActiveCashbackFidelityBalance_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkActiveCashbackFidelityBalance_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Customer",
      "kind": "LinkedField",
      "name": "customer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cashbackFidelityBalance",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "34275b02c417126e6bfc8bc833d52786";

export default node;
